const healModifierData = {
  1: {
    healMultiplier: 1,
  },
  2: {
    healMultiplier: 1,
  },
  3: {
    healMultiplier: 1,
  },
  4: {
    healMultiplier: 1,
  },
  5: {
    healMultiplier: 1,
  },
};

export default healModifierData;
